<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  mounted() {

  },
  methods: {

    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          { title: '交易产品', field: 'symbol' },
          { title: 'dataType', field: 'dataType', data: 0, hidden: true },
          { title: '订单号', field: 'orderId' },
          { title: '信號源成交号', field: 'signalDealId' },
          { title: '開始時間', field: 'startTime', type: 5 },
          { title: '結束時間', field: 'endTime', type: 5 },
          { click: window.$t('common.search') }
        ]
      },

      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.closeList,
        selection: false,
        sequence: true,
        method: 'get',
        size: 10,
        cols: [
          { title: '賬號ID', field: 'accountId' },
          { title: '賬號', field: 'customerNumber' },
          { title: '交易平台', field: 'platform' },
          { title: '交易产品', field: 'symbol' },
          { title: '产品簡稱', field: 'symbolDisplayName' },
          { title: '方向', field: 'direct' },
          {
            title: '提交/成交（手数）', field: 'volume', render: (data, full) => {
              return full.volume + ' / ' + full.actualVolume
            }
          },
          { title: '平倉价格', field: 'price' },
          { title: '开仓保证金', field: 'margin' },
          { title: '持倉號', field: 'positionId' },
          { title: '訂單ID', field: 'orderId' },
          { title: '成交ID', field: 'dealId' },
          { title: '信號源成交号', field: 'signalDealId' },
          {
            title: '开仓时间', field: 'openTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '开仓价格', field: 'openPrice' },
          { title: '盈虧', field: 'profit' },
          { title: '下單情況', field: 'comment' },
          {
            title: '生成時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '推送時間', field: 'sendToSocketTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '更新時間', field: 'updateTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '執行時間', field: 'exeTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        ]
      }
    }
  }
}
</script>
